import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_ERROR, LOGIN_GOOGLE_USER, CURRENT_AUTHENTICATED_USER, CURRENT_AUTHENTICATED_USER_SUCCESS, CURRENT_AUTHENTICATED_USER_ERROR, FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR, NEW_PASSWORD, NEW_PASSWORD_SUCCESS, NEW_PASSWORD_ERROR, COMPLETE_NEW_PASSWORD, COMPLETE_NEW_PASSWORD_SUCCESS, COMPLETE_NEW_PASSWORD_ERROR, LOGOUT_USER, LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD, } from '../actions';
export var login = function (email, password, history) { return ({
    type: LOGIN_USER,
    payload: { email: email, password: password, history: history },
}); };
export var loginWithCompleteNewPassword = function (userData) { return ({
    type: LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD,
    payload: userData,
}); };
export var loginSuccess = function () { return ({
    type: LOGIN_USER_SUCCESS,
}); };
export var loginError = function (message) { return ({
    type: LOGIN_USER_ERROR,
    payload: { message: message },
}); };
export var loginWithGoogle = function (user, history) {
    if (user === void 0) { user = null; }
    if (history === void 0) { history = null; }
    return ({
        type: LOGIN_GOOGLE_USER,
        payload: { user: user, history: history },
    });
};
export var currentAuthenticatedUser = function (history) { return ({
    type: CURRENT_AUTHENTICATED_USER,
    payload: { history: history },
}); };
export var currentAuthenticatedUserSuccess = function (token) { return ({
    type: CURRENT_AUTHENTICATED_USER_SUCCESS,
    payload: { token: token },
}); };
export var currentAuthenticatedUserError = function () { return ({
    type: CURRENT_AUTHENTICATED_USER_ERROR,
}); };
export var forgotPassword = function (email) { return ({
    type: FORGOT_PASSWORD,
    payload: { email: email },
}); };
export var forgotPasswordSuccess = function () { return ({
    type: FORGOT_PASSWORD_SUCCESS,
}); };
export var forgotPasswordError = function (message) { return ({
    type: FORGOT_PASSWORD_ERROR,
    payload: { message: message },
}); };
export var newPassword = function (email, code, password, history) { return ({
    type: NEW_PASSWORD,
    payload: { email: email, code: code, password: password, history: history },
}); };
export var newPasswordSuccess = function () { return ({
    type: NEW_PASSWORD_SUCCESS,
}); };
export var newPasswordError = function (message) { return ({
    type: NEW_PASSWORD_ERROR,
    payload: { message: message },
}); };
export var completeNewPassword = function (_a) {
    var user = _a.user, password = _a.password, history = _a.history;
    return ({
        type: COMPLETE_NEW_PASSWORD,
        payload: { user: user, password: password, history: history },
    });
};
export var completeNewPasswordSuccess = function () { return ({
    type: COMPLETE_NEW_PASSWORD_SUCCESS,
}); };
export var completeNewPasswordError = function (message) { return ({
    type: COMPLETE_NEW_PASSWORD_ERROR,
    payload: { message: message },
}); };
// export const registerUser = (user: any, history: any) => ({
//   type: REGISTER_USER,
//   payload: { user, history },
// });
// export const registerUserSuccess = (user: any) => ({
//   type: REGISTER_USER_SUCCESS,
//   payload: user,
// });
// export const registerUserError = (message: any) => ({
//   type: REGISTER_USER_ERROR,
//   payload: { message },
// });
// export const confirmRegisterUser = (user: any) => ({
//   type: CONFIRM_REGISTER_USER,
//   payload: { user },
// });
// export const confirmRegisterUserSuccess = () => ({
//   type: CONFIRM_REGISTER_USER_SUCCESS,
// });
// export const confirmRegisterUserError = (message: any) => ({
//   type: CONFIRM_REGISTER_USER_ERROR,
//   payload: { message },
// });
export var logoutUser = function (loginMessage) { return ({
    type: LOGOUT_USER,
    payload: { loginMessage: loginMessage },
}); };
